<template>
  <el-card id="myDatabaseOrderList">
    <template #header>
      <span>产品购买</span>
    </template>
    <el-row>
      <el-col>
        <PersonCenterTable v-bind="info" @get-data="getBuyInfo" :pagination-disabled="true">
          <template #tableColumn>
            <!--eslint-disable-->
            <el-table-column v-for="(column,index) in info.table.columns" :key="index" :show-overflow-tooltip="true"
                             :prop="column.prop" :label="column.label" :width="column.width">
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template v-slot="scope">
                <el-button style="width: 140px" type="primary" @click="openDialog(scope.row)">购买/开通/续费</el-button>
              </template>
            </el-table-column>
          </template>
        </PersonCenterTable>
      </el-col>
    </el-row>
    <order-dialog
        :companyId="companyId"
        :type="orderRowInfo.type"
        :dialog-visible="dialogVisible"
        :dialog-loading="dialogLoading"
        :dialogVisible.sync="dialogVisible"
        :dialogLoading.sync="dialogLoading"
        @pay-done="handlePayDone"
    />
  </el-card>
</template>

<script>
import PersonCenterTable from "@/pages/userCenter/ChildComps/PersonCenterTable";
import orderDialog from "@/components/OrderDialog/OrderDialogComponent";
import companyBuyMixin from "@/pages/userCenter/Mixins/CompanyBuyMixin";


export default {
  //此处定义传入的数据
  props: {
    companyId: Number,
  },
  components: {
    PersonCenterTable,
    orderDialog
  },
  mixins: [companyBuyMixin],
}
</script>

<style scoped>

</style>
